import { Alert } from "react-native";

const enableUserAction = (name, action) =>
  Alert.alert(
    `Enable ${name}'s account?`,
    `Are you sure you want to enable this user's account? They will be able to login into the app.`,
    [
      { text: "No", style: "cancel" },
      {
        text: "Yes",
        style: "default",
        onPress: action,
      },
    ]
  );

export default enableUserAction;
